<template>
    <div class="row">
        <div class="col">
            <div class="card card-form company-card">
                <div class="card-header certificate">
                    <div class="row">
                        <div class="col-12">
                            <div class="pull-left">
                                <span><i class="fa fa-list"></i> {{$t('company.certificate.label')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>{{$t('company.field.regNum')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyCertificateForm.regNum"
                                       :class="{invalid: $v.companyCertificateForm.regNum.$error}"
                                >
                                <div class="red" v-if="!$v.companyCertificateForm.regNum.required">{{$t('company.validation.regNum')}}</div>
                                <div class="red" v-if="!$v.companyCertificateForm.regNum.maxLength">{{$t('company.validation.regNumConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.giveName')}} <span class="red">*</span></label>
                                <textarea type="text" class="form-control"
                                          v-model="companyCertificateForm.giveName"
                                          :class="{invalid: $v.companyCertificateForm.giveName.$error}"
                                ></textarea>
                                <div class="red" v-if="!$v.companyCertificateForm.giveName.required">{{$t('company.validation.giveName')}}</div>
                                <div class="red" v-if="!$v.companyCertificateForm.giveName.maxLength">{{$t('company.validation.giveNameConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.startDate')}} <span class="red">*</span></label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="startDate"
                                            :clear-button="false"
                                            :class="{invalid : $v.startDate.$error}"
                                ></datepicker>
                                <div class="red" v-if="!$v.startDate.required">{{$t('company.validation.startDate')}}</div>
                            </div>
                          <!--  <div class="form-group">
                                <label>{{$t('company.field.endDate')}} <span class="red">*</span></label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="endDate"
                                            :clear-button="false"
                                            :class="{invalid : $v.endDate.$error}"
                                ></datepicker>
                                <div class="red" v-if="!$v.endDate.required">{{$t('company.validation.endDate')}}</div>
                            </div> -->
                        </div>
                        <drop-zone code="companyCertificatePictureFile"
                                   label="company.field.companyCertificatePictureFile"
                                   view="XL"
                                   folder="Company"
                                   subFolder="CompanyCertificate"
                                   :addRemoveLinks="hasCreate"
                                   :editable="hasCreate"
                                   :data="companyCertificateFiles"
                                   @change="(files) => {companyCertificateForm.companyCertificatePictureFile = files[0]}"
                                   :maxFiles="1"
                                   acceptedFiles="image/*"
                                   :has-error="$v.companyCertificateForm.companyCertificatePictureFile.id.$error"
                        ></drop-zone>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-right">
                                <router-link tag="button"
                                             class="all-btn ml-auto"
                                             v-if="!hasCreate && hasPermission('V2_COMPANY_ADD')"
                                             :to="{path: '/company/certificate/add', query: {isCreate: true}}"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('company.field.companyCreate')}}</span>
                                </router-link>
                                <button type="button"
                                        class="all-btn add-btn"
                                        v-else-if="hasCreate && hasPermission('V2_COMPANY_ADD')"
                                        @click="save"
                                        :disabled="processing"
                                >
                                    <i class="fa fa-check"></i>
                                    <span>{{$t('action.save')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DropZone from '@/views/dropZone/DropZone'
    import Datepicker from 'vuejs-datepicker';
    import {required,maxLength} from 'vuelidate/lib/validators';
    import {formatDate, parseDate} from '@/shared/utils';

    export default {
        name: "CompanyCertificateEdit",
        components: {
            DropZone,
            Datepicker
        },
        props: {
            data: Object
        },
        data() {
            return {
                processing: false,
                companyCertificateForm: {
                    id: null,
                    regNum: '',
                    giveName: '',
                    startDate: null,
                    endDate: null,
                    companyCertificatePictureFile: {}
                },
                startDate: null,
                endDate: null,
                companyCertificateFiles: []
            }
        },
        validations() {
            return {
                companyCertificateForm: {
                    regNum: {
                        required,
                        maxLength: maxLength(255)
                    },
                    giveName: {
                        required,
                        maxLength: maxLength(255)
                    },
                    companyCertificatePictureFile: {
                        id: {
                            required
                        }
                    }
                },
                startDate: {
                    required
                }
            }
        },
        computed: {
            hasCreate() {
                return this.$route.query.isCreate != null
            }
        },
        methods: {
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.companyCertificateForm.startDate = formatDate(this.startDate);
                this.companyCertificateForm.endDate = formatDate(this.endDate);

                this.$http.post('/company/certificate', this.companyCertificateForm)
                    .then(res => {
                        this.processing = false;
                        if (res.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.company.success'),
                                type: 'success'
                            });

                            this.$router.push('/company/profile')
                        }
                    }, ()=> {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.company.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            }
        },
        created() {

        },
        watch: {
            data: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.companyCertificateForm = val;
                        this.startDate = parseDate(val.startDate);
                        this.endDate = parseDate(val.endDate);
                        this.companyCertificateFiles.push(val.companyCertificatePictureFile);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .certificate {
        background-color: #00838f;
    }

    .card .card-header span {
        color: white;
        font-weight: bold;
        font-size: 15px;
    }
</style>